module.exports = __webpack_public_path__ + "static/img/speaker-on.46a3feb8.svg";